import { ArrowRight } from "lucide-react";
import { CountdownChip } from "@/components/quote/QuoteBanners";

export function GuestbookOffer({ holdDeadline }) {
  return (
    <section
      id="video-guestbook"
      data-testid="video-guestbook-section" data-track-section="guestbook"
      className="relative overflow-hidden"
    >
      <img
        src="https://img.youtube.com/vi/crM-ixYOXos/maxresdefault.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <iframe
          src="https://www.youtube.com/embed/crM-ixYOXos?autoplay=1&mute=1&loop=1&playlist=crM-ixYOXos&controls=0&rel=0&playsinline=1&modestbranding=1"
          title="Video Messages Guestbook background"
          allow="autoplay; encrypted-media"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100vw] h-[56.25vw] min-h-full min-w-[177.78vh]"
        />
      </div>
      <div className="absolute inset-0 bg-[#242C39]/90" />
      <div className="relative z-10 px-6 md:px-12 py-24 md:py-32 text-center text-white">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight font-medium mb-12">
            Secure your date within{" "}
            <span className="whitespace-nowrap">7 DAYS</span> to get our
            Video Messages Guestbook for FREE!{" "}
            <span className="italic font-light">(Usually £499)</span>
          </h2>
          {Number.isFinite(holdDeadline) && (
            <CountdownChip deadline={holdDeadline} testId="guestbook-countdown" />
          )}
          <div className="w-full aspect-video overflow-hidden mb-12 shadow-[0_20px_60px_rgba(0,0,0,0.4)]">
            <iframe
              src={`https://www.youtube.com/embed/crM-ixYOXos?rel=0&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`}
              title="Video Messages Guestbook"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              data-testid="guestbook-video-embed"
              data-track-video="crM-ixYOXos"
              className="w-full h-full"
            />
          </div>
          <a
            href="https://weddingvideoessex.co.uk/video-guestbook"
            target="_blank"
            rel="noreferrer"
            data-testid="guestbook-action-btn" data-track-click="guestbook-example"
            className="inline-flex items-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/30 hover:border-white/60 text-white px-10 py-4 text-xs tracking-overline uppercase font-medium transition-all group"
          >
            See the Guestbook in Action!
            <ArrowRight
              className="w-4 h-4 group-hover:translate-x-1 transition-transform"
              strokeWidth={1.5}
            />
          </a>
        </div>
      </div>
    </section>
  );
}
